import styled, { css } from 'styled-components'

export const SidebarFlavorText = styled.div<{ $chatLayout: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  padding-inline: 0.5rem;
  font-family: 'Roboto Mono', 'SF Mono', 'Menlo', monospace;
  font-size: 0.75rem;
  font-weight: 400;
  letter-spacing: 0.12em;
  line-height: 1.25;
  text-transform: uppercase;
  color: var(--muted-foreground);
  transition: ${({ $chatLayout }) =>
    $chatLayout ? 'opacity 150ms var(--ease-out-strong)' : 'none'};

  [data-collapsible='icon'] & {
    padding-inline: 0;
    opacity: 0;
  }
`

export const SidebarFlavorTextLine = styled.span`
  overflow: hidden;
  text-overflow: clip;
  white-space: nowrap;
`

export const SidebarFlavorSubTextLine = styled(SidebarFlavorTextLine)`
  font-size: 0.5rem;
`

export const SidebarPagesPane = styled.div<{ $chatLayout: boolean }>`
  min-height: 0;
  ${({ $chatLayout }) =>
    $chatLayout
      ? css`
          flex: none;
          overflow: clip;
        `
      : css`
          flex: 1 1 0%;
          overflow-y: auto;
        `}
`
